import {Component, OnInit} from '@angular/core';
import {RestService} from '../../shared/service/rest.service';
import {MyProfileModel} from 'src/shared/model/UserProfile';

import {AuthService} from 'src/shared/service/auth.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AbstractDataProvider} from '../AbstractDataProvider';
import {Subject} from 'rxjs';
import {DynamicModalService} from '../ui-components/dynamic-modals/dynamic-modal.service';
import {getErrorMessageText} from '../helper';
import {LoginProvider} from '../../shared/service/login.service';
import {finalize} from 'rxjs/operators';

export interface LoginDataModel {
  grant_type: string;
  username: string;
  password: string;
}

const CODE_WAITING_TIME = 60;

@Component({
  selector: 'app-login-2fa',
  templateUrl: './login-2fa.component.html',
  styleUrls: ['./login-2fa.component.scss'],
})
export class Login2FaComponent implements OnInit {
  userProfileEntity: MyProfileModel = new MyProfileModel();

  display = false;
  alertMessage: string;

  failed: number = 0;

  clientCode: string;
  code2fa: string;
  remember2fa: boolean;
  email: string;
  public modalData: any;

  showHeader = true;
  public subjectOnClose: Subject<any>;
  actionToPerform = '';
  secondCount = CODE_WAITING_TIME;
  loginData: LoginDataModel;

  constructor(
    public rest: RestService,
    private authService: AuthService,
    private dynamicModalService: DynamicModalService,
    private ngxService: NgxUiLoaderService,
    private loginProvider: LoginProvider,
    private abstractDataProvider: AbstractDataProvider) {
  }

  ngOnInit() {
    this.clientCode = this.authService.clientCode;
    this.email = this.modalData?.email ?? '';
    this.loginData = this.modalData?.loginData;

    setInterval((() => this.secondCount ? this.secondCount-- : this.secondCount = 0), 1000);
  }

  resendCode(): void {
    this.code2fa = '';
    this.ngxService.start();
    this.loginProvider.loginToken(this.loginData, this.authService.get2faRememberToken(this.loginData.username))
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe(posts => {
          this.secondCount = CODE_WAITING_TIME;
        },
        error => {
          if (error?.error?.error === '2_FA_CODE_SENT') {
            this.secondCount = CODE_WAITING_TIME;
            this.display = true;
            this.alertMessage = 'A new code has been sent, please check the email address assigned to your account.';
          }
          else {
            this.display = true;
            this.alertMessage = getErrorMessageText(error);
          }
        });
  }

  submit() {
    if (!this.code2fa) {
      this.display = true;
      this.alertMessage = 'Please enter the code.';
      return;
    }

    this.ngxService.start();
    this.loginProvider.loginToken2fa(this.loginData, this.code2fa, this.remember2fa)
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe(
        posts => {
          this.close(posts);
        },
        error => {
          this.ngxService.stop();
          if (++this.failed > 2) {
            this.alertMessage = 'Invalid authorization code - Too many attempts have been made. You must login again.';
            this.actionToPerform = 'closeDialog';
          }
          else {
            this.alertMessage = getErrorMessageText(error);
          }
          if (error?.error?.error === 'MANYINVALIDATTEMPTS') {
            this.actionToPerform = 'closeDialog';
          }
          this.display = true;
        });

  }

  close(data: { code: string, remember2fa: boolean } = null) {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(data);
      this.dynamicModalService.subject.next(null);
    } else {
      this.authService.navigateToUrl('home');
    }
  }

  cancel() {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(null);
      this.dynamicModalService.subject.next(null);
    } else {
      this.authService.navigateToUrl('home');
    }
  }

  onConfirm() {
    this.display = false;
    if (this.actionToPerform === 'closeDialog') {
      this.cancel();
    }
  }
}
